import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { createRoom, joinRoom, getIdentity } from "./ballparkRoom"
import { Screen, BpButton, C, F, useBallparkFonts } from "./BallparkUI"

const inputStyle = {
  height: 52,
  borderRadius: 12,
  border: `1.5px solid ${C.borderDark}`,
  background: C.card,
  padding: "0 16px",
  fontSize: 17,
  fontWeight: 700,
  fontFamily: F.body,
  color: C.ink,
  width: "100%",
  boxSizing: "border-box",
}

const BallparkLanding = () => {
  useBallparkFonts()
  const navigate = useNavigate()
  const [name, setName] = useState(getIdentity().name)
  const [code, setCode] = useState("")
  const [mode, setMode] = useState(null) // null | "create" | "join"
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState("")

  const handleCreate = async () => {
    setBusy(true)
    setError("")
    try {
      const newCode = await createRoom(name.trim())
      navigate(`/ballpark/${newCode}`)
    } catch (e) {
      setError("Couldn't create a game. Try again.")
      setBusy(false)
    }
  }

  const handleJoin = async () => {
    setBusy(true)
    setError("")
    try {
      await joinRoom(code.trim().toUpperCase(), name.trim())
      navigate(`/ballpark/${code.trim().toUpperCase()}`)
    } catch (e) {
      setError(
        e.message === "not-found"
          ? "No game with that code. Check it and try again."
          : "Couldn't join. Try again."
      )
      setBusy(false)
    }
  }

  return (
    <Screen style={{ justifyContent: "center", gap: 16 }}>
      <div style={{ textAlign: "center", marginBottom: 8 }}>
        <img
          src="/images/ballpark_logo.png"
          alt="Ballpark Logo"
          style={{
            width: 140,
            height: 140,
            objectFit: "contain",
            margin: "0 auto 12px",
            display: "block",
            filter: "drop-shadow(0 6px 12px rgba(59, 46, 34, 0.15))",
          }}
        />
        <div style={{ fontFamily: F.display, fontWeight: 800, fontSize: 40 }}>
          Ballpark
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.muted }}>
          Guess the number, then bet on the best guess.
        </div>
      </div>

      <input
        style={inputStyle}
        placeholder="Your name"
        value={name}
        maxLength={16}
        onChange={(e) => setName(e.target.value)}
      />

      {mode === "join" && (
        <input
          style={{ ...inputStyle, letterSpacing: 2, textTransform: "uppercase" }}
          placeholder="ROOM CODE (e.g. PLUM-42)"
          value={code}
          maxLength={9}
          onChange={(e) => setCode(e.target.value)}
        />
      )}

      {error && (
        <div style={{ color: C.rust, fontWeight: 700, fontSize: 14, textAlign: "center" }}>
          {error}
        </div>
      )}

      {mode !== "join" ? (
        <>
          <BpButton onClick={handleCreate} disabled={busy || !name.trim()}>
            {busy ? "Creating…" : "Create a game"}
          </BpButton>
          <BpButton variant="panel" onClick={() => setMode("join")} disabled={busy}>
            Join with a code
          </BpButton>
        </>
      ) : (
        <>
          <BpButton onClick={handleJoin} disabled={busy || !name.trim() || !code.trim()}>
            {busy ? "Joining…" : "Join game"}
          </BpButton>
          <BpButton variant="ghost" onClick={() => setMode(null)} disabled={busy}>
            Back
          </BpButton>
        </>
      )}
    </Screen>
  )
}

export default BallparkLanding
